import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgCryptoAtm(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="6 10 50 43"
      fill="none"
      {...props}
    >
      <path
        stroke={props.secondaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12.302 28.195a12.855 12.855 0 1 1 22.168-1.837"
      />
      <path
        stroke={props.primaryColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M43.051 30.031h-4.398c-.54 0-1.072.121-1.555.356l-3.75 1.815a3.6 3.6 0 0 1-1.557.354h-1.914c-1.85 0-3.353 1.453-3.353 3.245 0 .073.05.136.121.156l4.667 1.29a3.58 3.58 0 0 0 2.512-.227l4.008-1.939m-11.308-.46-8.434-2.59a3.64 3.64 0 0 0-4.047 1.383c-.678.936-.402 2.28.586 2.85l13.8 7.964a3.68 3.68 0 0 0 2.879.343l11.743-3.485M19.983 25.747v-9.795m2.869 0v-2.448m0 14.69v-2.447m-2.869-4.897h5.737m0 0c.951 0 1.723.822 1.723 1.836v1.225c0 1.013-.772 1.836-1.721 1.836H18.26m7.459-4.897c.95 0 1.723-.823 1.723-1.837v-1.225c0-1.013-.772-1.836-1.721-1.836H18.26"
      />
      <circle cx={43.053} cy={44.726} r={4.591} fill="#fff" />
      <path
        fill="#2BBF9F"
        d="M43.206 51a6.12 6.12 0 1 1 0-12.242 6.12 6.12 0 0 1 0 12.242m-.61-3.673L46.924 43l-.866-.865-3.462 3.462-1.731-1.731-.866.865z"
      />
    </svg>
  );
}
export default SvgCryptoAtm;
